"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function LoadedContent(props) {
    var penLink = "https://codepen.io/" + props.user + "/pen/" + props.hash + "/";
    var userProfileLink = "https://codepen.io/" + props.user;
    return (React.createElement("div", null,
        "See the Pen ",
        React.createElement("a", { href: penLink }, props.title),
        "by ",
        props.user,
        " (",
        React.createElement("a", { href: userProfileLink },
            "@",
            props.user),
        ") on ",
        React.createElement("a", { href: "https://codepen.io" }, "CodePen"),
        "."));
}
exports.default = LoadedContent;
//# sourceMappingURL=LoadedContent.js.map